import { Routes, Route } from "react-router-dom";

import {auth, logout } from "./firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import './App.scss';
import Login from './Login';
import Dashboard from './Dashboard';
import Landing from "./Landing";
import Container from "react-bootstrap/Container";
import New from './New';
import User from "./User";
import Signup from "./Signup";
import Button from "react-bootstrap/Button";
import ResetPassword from "./ResetPassword";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const axios = require("axios").default;

function App() {
  const navigate = useNavigate();
  const [user] = useAuthState(auth);
  const signout = function() {
    logout();
    navigate("/");
  }
  axios.interceptors.request.use(async function(config: any) {
    config.headers.authorization = await auth.currentUser?.getIdToken();
    return config;
  }, function(error:any) {
    return Promise.reject(error);
  });
  return (
    <Container>
      <header className="d-flex flex-wrap justify-content-center py-3 mb-4 bg-primary">
        <Link to="/" className="d-flex align-items-center mb-5 mb-md-0 link-light">
          <span className="fs-4 ms-5"><img src="./logo.png" width="100" height="100" alt="Gran Recogida"/></span>
        </Link>
        <h1 className="text-light me-md-auto ps-5">Gran Recogida de Alimentos 2023</h1>
        <ul className="nav nav-pills me-5">
          {user &&
            <li className="nav-item" ><Button onClick={signout}>Cerrar la sesion</Button></li>
          }
        </ul>
      </header>
      <Routes>
        <Route path="/" element={<Landing />}/>
        <Route path="/Login" element={<Login />}/>
        <Route path="/dashboard" element={<Dashboard />}/>
        <Route path="/new" element={<New />}/>
        <Route path="/users/new" element={<User />}/>
        <Route path="/register" element={<Signup />}/>
        <Route path="/reset" element={<ResetPassword />}/>
      </Routes>
    </Container>
  );
}

export default App;
